import { Dispatch } from "redux";
import { Assertion, RelyingParty, RiskLevel } from "@idw-types/data/reference-data/generic";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import { formatExportAssertionFraudResults } from "@formatters/export-assertion-fraud-results/export-assertion-fraud-result-formatter";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import { downloadAssertionFraudResultsFile } from "@utils/file-util";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { exportAssertionFraudRequest } from "@requests/reports/export-assertion-fraud";
import { setFraudReportExportLoading } from "@redux/actions/fraud-report-actions";
import { generateQueryParameters } from "@utils/query-parameter-util";

export const exportFraudReportReduxRequest = (dispatch: Dispatch) => async (
    companyId: string,
    rpServiceIds: Array<string>,
    relyingPartyIds: Array<string>,
    assertionIds: Array<string>,
    riskLevelIds: Array<string>,
    startDate: Date,
    endDate: Date,
    assertions: Array<Assertion>,
    relyingParties: Array<RelyingParty>,
    riskLevels: Array<RiskLevel>,
    rpServices: Array<RpServiceConfiguration>
) => {
    dispatch(setFraudReportExportLoading(true));

    const queryParameters = generateQueryParameters({
        rpAXNServiceIDs: rpServiceIds,
        companyIDs: companyId,
        relyingPartyIDs: relyingPartyIds,
        assertionIDs: assertionIds,
        riskLevelIDs: riskLevelIds,
        startDate: format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        endDate: format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dateFormat: SERVER_DATE_TIME_FORMAT
    });

    const { data, error } = await exportAssertionFraudRequest(queryParameters);
    if (data) {
        const formattedAssertionFraudResults = formatExportAssertionFraudResults(
            data,
            assertions,
            relyingParties,
            riskLevels,
            rpServices
        );

        await downloadAssertionFraudResultsFile(
            `Fraud_Report_Export_${format(startDate, "MM_dd_yyyy")}_to_${format(endDate, "MM_dd_yyyy")}`,
            formattedAssertionFraudResults
        );
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.exportAssertionFraud.error.title,
            resources.requests.exportAssertionFraud.error.message
        );
    }
    dispatch(setFraudReportExportLoading(false));
};